import { render, staticRenderFns } from "./DataListTitle.vue?vue&type=template&id=4ca19576&"
import script from "./DataListTitle.vue?vue&type=script&lang=js&"
export * from "./DataListTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports